var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-box',[_c('o-form',{attrs:{"title":_vm.$t('cpv.addAllowedHash'),"initial-values":_vm.initialValues,"inputs":_vm.inputs,"submit-text":_vm.$t('common.save')},on:{"submit":_vm.addAllowedHash}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }